<template>
  <div class="index">
    <van-nav-bar
        title="公司概况"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />


    <div class="van-doc-demo-block__card">
      <van-panel title="公司概况" desc="江山市江城管道燃气有限公司" >
        <div class="doc_title">
          江山市江城管道燃气有限公司成立于2010年10月，是我市唯一取得《管道燃气特许经营许可证》的企业。
          <br><br>

          2014年建成了位于何家山的中心气源站（占地面积30.53亩，年输气能力1.46亿立方，已建4个100立方液化天然气储罐，储气能力24万立方）和位于四都的高中压调压站（占地3.93亩，年输气能力2190万立方）。
          2025年建成位于莲华山的综合气源站（占地32.46亩，年输气能力3亿立方，已建4个200立方液化天然气储罐，储气能力48万立方）。
          <br><br>
          2014年接通西气东输管输气源。主管网已基本覆盖城区，基本完成了城南开发区、山海协作园区、莲华山大道主干管道敷设，并延伸至贺村镇中心南街和石门镇“蓝城.春风江山”项目区。
          <br><br>
        </div>
      </van-panel>
    </div>





  </div>
</template>
<script>
export default {
  name: 'page_bind',
  data() {
    return {

    };
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    }

  },
  mounted () {

  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
.doc-demo-block__card {
  margin: 16px 12px 0px;
  overflow: hidden;
  border-radius: 8px;
}
.doc_title {
  margin: 0;
  padding: 22px 16px 0px 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
</style>